export default "__VITE_ASSET__B9ta9SzU__"